import { methods } from "./core/methods.js";

export const ServiceClient = {
  dataCore,
  dataCoreAbsURL,
  getAPIUrl,
  handleUnauthorized,
  insertAnotherParameter,
};

const API = [
  { name: "", url: "UNKNOWN" },
  { name: "point", url: "/rest/ecapp/point.json" },
  { name: "places", url: "/rest/ecapp/places.json" },
  { name: "escbmain", url: "/rest/ecapp/escb/main.json" },
  { name: "escbchartpies", url: "/rest/ecapp/escb/chartpies.json" },
  { name: "escbchart", url: "/rest/ecapp/escb/chart.json" },
  { name: "evccommand", url: "/rest/ecapp/evccommand.json" },
  { name: "evcstation", url: "/rest/ecapp/evcstation.json" },
  { name: "evcstations", url: "/rest/ecapp/evcstations.json" },
  { name: "evcsession", url: "/rest/ecapp/evcsession.json" },
  { name: "evcsessions", url: "/rest/ecapp/evcsessions.json" },
  { name: "evcparams", url: "/rest/ecapp/evcparams.json" },
  { name: "calibration", url: "/rest/ecapp/calibration.json" },
  { name: "command", url: "/rest/ecapp/command.json" },
  { name: "config", url: "/rest/ecapp/config.json" },
  { name: "external", url: "/rest/ecapp/external.json" },
  { name: "events", url: "/rest/ecapp/events.json" },
  { name: "chart", url: "/rest/ecapp/chart.json" },
  { name: "chartpies", url: "/rest/ecapp/chartpies.json" },
  { name: "main", url: "/rest/ecapp/main.json" },
  { name: "parameters", url: "/rest/ecapp/parameters.json" },
  { name: "ppds", url: "/rest/ecapp/ppds.json" },
  { name: "upgrade", url: "/rest/ecapp/upgrade.json" },
  { name: "login", url: "/rest/ecapp/login.json" },
];

/*
 *
 */
function insertAnotherParameter(data) {
  if (data.slice(-1) != "&" && data.slice(-1) != "?") {
    if (data != "") {
      data += "&";
    }
  }

  return data;
}

function getAPIUrl(name) {
  for (let index = 0; index < API.length; index++) {
    if (API[index].name == name) {
      return API[index].url;
    }
  }

  return API[0].url;
}

/**
 * dataCore -
 * @param {relativeURL} - a
 * @param {body} - b
 * @param {parameters} - c
 * @param {post} - d
 * @return {Promise} - zz
 *
 * */
function dataCore(relativeURL, body, parameters, method) {
  let user, requestOptions;

  let relativeURLParam = "";

  if (method == "post" || method == "POST") {
    [user, requestOptions] = methods.post(body);
  } else if (method == "get" || method == "GET") {
    [user, requestOptions] = methods.get(body);
  } else {
    [user, requestOptions] = methods.get(body);
  }

  let l = "";

  if (user.appurl.toLowerCase().includes("https://inveczkusebna.iqhouse.cz")) {
    if (relativeURL.toLowerCase().includes("/rest/ecapp/chart.json")) {
      relativeURL = "/rest/ecapp/chartst.json";

      l = "https://ecapp.energycloud.cz";

      parameters += "&stationid=1657";

      delete requestOptions.headers.Authorization;
    } else {
      l = user.appurl;
    }
  } else {
    l = user.appurl;
  }

  relativeURLParam = relativeURL + (parameters != null ? parameters : "");

  return new Promise((resolve, reject) => {
    fetch(l + relativeURLParam, requestOptions)
      .then((response) => {
        if (!response.ok) {
          reject(response.status);
        }
        resolve(response.json());
      })
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        if (err.toString().includes("NetworkError when attempting to fetch resource") || err.toString().includes("Failed to fetch")) {
          resolve(null);
        } else {
          reject(err);
        }
      });
  });
}

function dataCoreAbsURL(absoluteURL, parameters) {
  let relativeURLParam = "";

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  relativeURLParam = absoluteURL + (parameters != null ? parameters : "");

  return new Promise((resolve, reject) => {
    fetch(relativeURLParam, requestOptions)
      .then((response) => {
        if (!response.ok) {
          reject(response.status);
        }
        resolve(response.json());
      })
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        if (err.toString().includes("NetworkError when attempting to fetch resource") || err.toString().includes("Failed to fetch")) {
          resolve(null);
        } else {
          reject(err);
        }
      });
  });
}

function handleUnauthorized(error, router) {
  if (error == 401) {
    router.push({ name: "login" });
    location.reload(true);
  }

  return null;
}
